module.exports = __webpack_public_path__ + "img/icon-transfer.a761150f.svg";